import { groq } from 'next-sanity'
export const getSettingsQuery = (locale: AppLocale) => groq`
  *[_type == "settings"][0] {
      "title": title.${locale},
      "description": description.${locale},
      banner,
      "h1": h1.${locale},
      "h2": h2.${locale},
      "description_1": description_1.${locale},
      "description_2": description_2.${locale},
      "description_3": description_3.${locale},
      "faq": faq.${locale},
      "dynamicFooter": dynamic_footer.${locale},
    }
  `

export const getLanguageOrderQuery = groq`
  *[_type == "settings"][0] {
    language_order[]-> {
      code,
      text,
      priority
    }
  }
`
